<template>
    <div class="container-above pricing pricing-card">
        <div class="card mb-4" style="height:100%!important">
            <div class="card-body">
                <h5 class="card-title text-muted text-uppercase
                text-center">{{chartModal.chart_title}}<i @click="closeModal"
                                                          class="fa fa-times pull-right fa-lg close-icon"></i></h5>
                <hr>
                <div v-if="table.rows.length !== 0">
                    <vue-good-table
                            :columns="columns"
                            :isLoading.sync="isLoading"
                            :pagination-options="{enabled: true}"
                            :rows="table.rows"
                            :totalRows="table.totalRecords"
                            :sort-options="{
                                enabled: false
                            }"
                            :paginationOptions=paginationOptions
                            @on-column-filter="onColumnFilter"
                            @on-page-change="onPageChange"
                            @on-per-page-change="onPerPageChange"
                            @on-sort-change="onSortChange"
                            mode="remote"
                            styleClass="table table-hover">
                        <template slot="table-row" slot-scope="props">
                        <span v-if="props.column.field == 'url'">
                            <a :href="props.row.url" target="_blank">Podio</a>
                        </span>
                            <span v-else-if="props.column.field == 'contact'" v-html="props.row.contact" />
                            <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
                        </template>
                    </vue-good-table>
                </div>
                <div v-else>
                    <loader-table></loader-table>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    .close-icon:hover {
        cursor: pointer;
        color: #dc3545;
    }

    .container-above {
        position: absolute;
        transition: 0.5s;
        top: 80px;
        /*height: 89%;*/
        /*left: 0;*/
        right: 10px;
        margin: 0 auto;
        transition: .5s transform ease-in-out;
    }

    .vgt-wrap__footer {
        color: #ffffff;
        padding: 0.5em !important;
        border: none !important;
        border-top: 1px solid #dcdfe6 !important;
        background: #ffffff !important;
    }

    /*.pricing {*/
    /*    margin-left: 300px;*/
    /*}*/

    .pricing .card {
        border: none;
        border-radius: 1rem;
        transition: all 0.2s;
        box-shadow: 0 0.5rem 1rem 0 rgba(0, 0, 0, 0.1);
    }
</style>
<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import {VueGoodTable} from 'vue-good-table'
    import {mapActions, mapGetters} from 'vuex'
    import loaderTable from '@/components/charts/loaders/loader-table.vue'

    export default {
        name: 'modal',
        props: ['reload'],
        data() {
            return {
                isLoading: false,
                paginationOptions: {
                    enabled: true,
                },
                columns: [
                    {
                        label: 'Company',
                        field: 'company',
                    },
                    {
                        label: 'Contact',
                        field: 'contact'
                    },
                    {
                        label: 'Country',
                        field: 'country',
                    },
                    {
                        label: 'Sales',
                        field: 'sales_modular',
                    },
                    {
                        label: 'Link',
                        field: 'url'
                    }
                ],
            };
        },
        computed: mapGetters({
                chartModal: 'CHART_MODAL',
                table: 'TABLE'
            }
        ),
        components: {
            VueGoodTable,
            loaderTable
        },
        mounted() {
            this.loadItems()
        },
        methods: {
            ...mapActions({
                    loadItems: 'CALL_CHART_MODAL_SERVERDATA',
                }
            ),
            closeModal() {
                this.$store.dispatch('CLOSE_CHART_MODAL')
            },
            updateParams(newProps) {
                this.$store.dispatch('CHANGE_SERVERPARAMS', newProps)
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.paginationOptions.setCurrentPage = params.currentPage
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params.sortType,
                        field: this.columns[params.columnIndex].field,
                    }],
                });
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },


        },
        watch: {
            reload: async function(){
                this.isLoading = true
                await this.onPageChange(1)
                this.paginationOptions = Object.assign({}, this.paginationOptions, {setCurrentPage: 1});
                this.isLoading = false
            }
        }
    }
</script>
